import MarketTypeGroupings from "app/components/UnsummarizedMarketsModal/components/ModalMarketTypeGroupings/ModalMarketTypeGroupings";
import { SessionHelper } from "app/helpers/sessionHelper";
import { EventType } from "app/types/eventType";
import { Component } from "react";
import EventName from "../EventName/EventName";
import Header from "../Header/Header";
import "./WidgetNotAvailable.scss";
type Props = {
  userTimezone: Record<string, any>;
  fetchEventData: Function;
  event: EventType;
};

class WidgetNotAvailable extends Component<Props> {
  render() {
    const { event, userTimezone, fetchEventData } = this.props;

    return (
      <div className={"widget-not-available"}>
        <Header event={event} />
        <EventName
          event={event}
          userTimezone={userTimezone}
          fetchEventData={fetchEventData}
        />
        {!SessionHelper.isAsianRouteAndSessionView() && (
          <MarketTypeGroupings event={event} sportId={event["sportId"]} />
        )}
      </div>
    );
  }
}

export default WidgetNotAvailable;
